import React, { useState } from "react";
import TextInputLabelHookForm from "components/TextInputLabelHookForm";
import { useFormContext } from "react-hook-form";
import { IOperationsGroup } from "../types";
import { editStateOperationsGroup } from "../atoms/atoms";
import { useRecoilValue } from "recoil";
import CheckBoxLabelHookForm from "components/CheckBoxLabelHookForm";

export const OperationsGroupDetails = (props: {
  setChanges: React.Dispatch<React.SetStateAction<boolean>>;
  data: IOperationsGroup | undefined;
}) => {
  // Props drilled
  const { data, setChanges } = props;

  // Recoil Hook
  const edit = useRecoilValue(editStateOperationsGroup);

  // Form Functions
  const { register } = useFormContext();
  const formMethods = useFormContext();

  // Local Hooks
  const [inputData, setInputData] = useState(data?.operationName || "");
  const [checkBoxChanges, setCheckBoxChanges] = useState(data?.isActive);
  const [descData, setDescData] = useState(data?.description);

  return (
    <>
      <div className="bg-bgDB">
        <div className="m-2 bg-white shadow-lg h-full">
          <div className="grid grid-cols-11 mx-3 gap-x-6 py-2">
            <div className="col-span-4 my-1">
              <TextInputLabelHookForm
                name="operationName"
                label="Operations Group Name"
                type="text"
                onChange={(e) => {
                  setInputData(e.target.value);

                  if (
                    e.target.value.trim() === "" ||
                    (e.target.value === data?.operationName &&
                      checkBoxChanges == data?.isActive &&
                      descData == data?.description)
                  ) {
                    setChanges(false);
                  } else {
                    setChanges(true);
                  }
                  e.target.value = e.target.value.replace(/\s+/g, " ");
                }}
                required={true}
                className={
                  formMethods.formState.errors.operationName &&
                  formMethods.formState.errors.operationName.message &&
                  "border-2 border-red-500 col-span-2 "
                }
                register={formMethods.register("operationName", {
                  required: {
                    value: true,
                    message: "Required Field",
                  },
                })}
                maxLength={255}
              />
            </div>

            <div className="col-span-3 my-1">
              <TextInputLabelHookForm
                name="description"
                label="Description"
                type="text"
                onChange={(e) => {
                  setDescData(e.target.value);

                  if (
                    e.target.value.trim() === "" ||
                    (e.target.value === data?.description &&
                      checkBoxChanges == data?.isActive &&
                      inputData == data?.operationName)
                  ) {
                    setChanges(false);
                  } else {
                    setChanges(true);
                  }
                  e.target.value = e.target.value.replace(/\s+/g, " ");
                }}
                required={true}
                className={
                  formMethods.formState.errors.description &&
                  formMethods.formState.errors.description.message &&
                  "border-2 border-red-500 col-span-2 "
                }
                register={formMethods.register("description", {
                  required: {
                    value: true,
                    message: "Required Field",
                  },
                })}
                maxLength={255}
              />
            </div>

            {edit && (
              <div className="col-span-4 my-1 mx-3">
                <CheckBoxLabelHookForm
                  name="isActive"
                  label={
                    checkBoxChanges
                      ? "Uncheck to Deactivate"
                      : "Check to Activate"
                  }
                  type="checkbox"
                  validation={{
                    required: {
                      value: false,
                      message: "Required Field",
                    },
                  }}
                  onClick={(e) => {
                    setCheckBoxChanges(e.target.checked);

                    if (
                      inputData?.trim() === "" ||
                      (e.target.checked === data?.isActive &&
                        inputData == data?.operationName &&
                        descData == data?.description)
                    ) {
                      setChanges(false);
                    } else {
                      setChanges(true);
                    }
                  }}
                  register={register}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default OperationsGroupDetails;
